import React from 'react';
import { useSelector } from 'react-redux';
import { selectToastStatus } from 'reducers/misc';

const Toast = () => {
  const toastStatus = useSelector(selectToastStatus);
  if (!toastStatus.open) return null;
  return (
    <div className={`Toast ${toastStatus.message ? 'Show' : 'Hide'}`}>
      <p className="Message">{toastStatus.message}</p>
    </div>
  );
};

export default Toast;
